import { Component } from '@angular/core';

@Component({
  selector: 'app-basic',
  imports: [],
  templateUrl: './basic.component.html',
  styleUrl: './basic.component.scss'
})
export class BasicComponent {

}
